import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";
import Section12 from "./Section12";


export default function EmailMarketing() {
  return (
    <div className="Email-Marketing pt-[160px] sm:pt-0">
      <Helmet>
        <title>Top Email Marketing Services | Best Email Marketing Company</title>
        <meta
        name="description"
        content="Boost sales and engagement with best email marketing services. Mean3 delivers personalized campaigns, automation, and proven ROI."
        />
      </Helmet>
      
      <Section1 />
      <Section7 />
      <Section8 />


      {/* <Section2 /> */}
      <Section3 />
      <Section9 />
      <Section10 />
      
      <Section4 />
      <Section11 />
      <Section12 />
      <Section5 />
      <Section6 />
    </div>
  );
}
